var map = {
	"./BG1.webp": 2203,
	"./BG10.webp": 61437,
	"./BG11.webp": 17874,
	"./BG12.webp": 63219,
	"./BG13.webp": 52784,
	"./BG14.webp": 83209,
	"./BG15.webp": 13486,
	"./BG16.webp": 66831,
	"./BG17.webp": 15244,
	"./BG18.webp": 7173,
	"./BG19.webp": 93146,
	"./BG2.webp": 79834,
	"./BG20.webp": 42854,
	"./BG21.webp": 12609,
	"./BG22.webp": 71012,
	"./BG23.webp": 85191,
	"./BG3.webp": 44005,
	"./BG4.webp": 77639,
	"./BG5.webp": 11031,
	"./BG6.webp": 50358,
	"./BG7.webp": 50385,
	"./BG8.webp": 62768,
	"./BG9.webp": 88531
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35705;